import { commonSearchSchema } from './commonSearchSchema';
import { optionalSearchString } from './search-param-schemas';

/**
 * Parametri del Monitoraggio, validati sul layout e quindi comuni a tutte le
 * sotto-pagine: tab di stato delle esecuzioni (`subTab`) e, col dettaglio di
 * un job aperto, la sua coda e il suo flow (`jobQueue`, `jobFlow`: tolti
 * tornando alla lista). Il vecchio `?period=` non c'è più: nessun dato del
 * monitor dipende da un periodo finché il registro delle esecuzioni non è
 * alimentato, e il router scarta la chiave dei link vecchi.
 */
export const systemMonitorSearchSchema = commonSearchSchema.extend({
  subTab: optionalSearchString(),
  jobQueue: optionalSearchString(),
  jobFlow: optionalSearchString(),
});
